export interface IMedia {
  url: string;

  height: number;

  width: number;
}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface IImage extends IMedia {
  shareCardCoverImage?: string;
  gptImageDescription?: string;
}

export enum EVideoMuteStatus {
  NORMAL = 0,
  MUTED = 1,
}

export interface IVideo extends IMedia {
  muteStatus: EVideoMuteStatus;
  duration: number;
}

export const VideoUtils = {
  durationTo8601: (duration: number) => {
    const hour = Math.trunc(duration / 3600);
    const minute = Math.trunc((duration - hour * 3600) / 60);
    const second = Math.trunc(duration - (hour * 3600 + minute * 60));
    let ret = 'PT';
    if (hour) {
      ret += `${hour}H`;
    }
    if (minute) {
      ret += `${minute}M`;
    }
    if ((!hour && !minute) || second) {
      ret += `${second}S`;
    }
    return ret;
  },
};
